var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 50 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_241_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_241_6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_241_6",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_241_6",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAzklEQVR4nO3YQQ3DQBAEQQMxieUx/Ok4FPKwNHtJlbQEpu3PXRcAAAAAAAAA8IrJ/bj76w3eWV2Q562PTpDs+oMFyZ8FAQAAADZpP0XMYSdI+hEESX94QdIfW5D0BxYk/VFXBwEAAAA2aT9FzGEnSPoRBEl/eEHSH1uQ9AcWJP1RBUl/SEEWjDcnBgEAAAA2aT9FzGEnSPoRBEl/eEHSH1uQ9AcWJP1RBUl/SEEWjDeC9AcbQfojjSD9YUaQ/hiz4NpPXQAAAAAAAABw/YgPnN8ykzTIFIIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineWidth);
export default __webpack_public_path__ + "static/media/LineWidth.0a001393d54352d709f0729ceb28ff1e.svg";
export { ForwardRef as ReactComponent };